import type { HistoryPoint } from './types';

type Props = { points: HistoryPoint[]; className?: string };

/** Malý graf vývoje hodnoty skladu. Méně než 2 dny dat → jen popisek. */
export function Sparkline({ points, className = '' }: Props) {
  if (points.length < 2) {
    return (
      <div
        className={`flex items-center justify-center text-[11px] text-text-muted text-center ${className}`}
      >
        Graf se kreslí
        <br />
        od zítřka
      </div>
    );
  }
  const W = 120;
  const H = 40;
  const values = points.map((p) => p.valueNet);
  const min = Math.min(...values);
  const max = Math.max(...values);
  const span = max - min || 1;
  const coords = points.map((p, i) => {
    const x = (i / (points.length - 1)) * W;
    // Rovná čára (beze změny) → doprostřed, ne ke dnu.
    const y = max === min ? H / 2 : H - 2 - ((p.valueNet - min) / span) * (H - 4);
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  });
  const first = points[0]?.day ?? '';
  const last = points[points.length - 1]?.day ?? '';
  return (
    <svg
      viewBox={`0 0 ${W} ${H}`}
      preserveAspectRatio="none"
      className={`text-success ${className}`}
      role="img"
      aria-label={`Vývoj hodnoty ${first} – ${last}`}
    >
      <title>{`Vývoj hodnoty ${first} – ${last}`}</title>
      <polyline
        points={coords.join(' ')}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}
